import styles from "./UploadSuccess.module.css";
import closebutton from "../../assests/closebutton.svg";
import LeftButton from "../Assets/Back.svg";

import ReactPlayer from "react-player";
import Backbutton from "../Assets/Back.svg";
import DeleteModel from "../../Components/Profile/DeleteModel";
import { useContext, useEffect, useState } from "react";
import UploadSucessDelete from "./UploadSucessDelete";
import close from "../../assests/closebutton.svg";
import Carousel from "../Carousel/Carousel";
import WhatsAppButton from "../WhatsAppButton/WhatsAppButton";
import { useUserAuth } from "../../context/UserAuthContext";
import { useNavigate } from "react-router";
import Context from "../../context/Context";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import axios from "axios";
import { createSearchParams } from "react-router-dom";
import AudioPlayerWithoutDownload from "../AudioPlayerWithoutDownload/AudioPlayerWithoutDownload";
import copyLinkImage from "../../assests/share/copyLink.svg";
import copySuccess from "../../assests/share/copySuccess.svg";
import facebook from "../../assests/share/fbLogo.svg";
import whatsapp from "../../assests/share/whatsApp.svg";
import twitter from "../../assests/posterCreation/twitterX.svg";
import LinkedIn from "../../assests/share/LinkedIn.svg";
import CopyToClipboard from "react-copy-to-clipboard";

function UploadSuccess({
  uploadSuccessFile,
  singleFileDetails,
  setShowPreview,
  token,
  setUploadSucccess,
  contestDetails,
  handleBackClick,
}) {
  const [showDelete, setShowDelete] = useState(false);
  const [uploadNotification, setUploadNotification] = useState(true);
  const [showcase, setShowcase] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const { newUserId, searchParams } = useUserAuth();
  const userId = localStorage.getItem("userId");
  let userIdFromLocalOrApi = newUserId || userId;
  const { preview, entryUploadResponse, buildType, details } =
    useContext(Context);
  const navigate = useNavigate();
  const handleNavigateToContest = () => {
    setUploadSucccess(false);

    navigate({
      pathname: `/${contestDetails?.orgDomain}/${contestDetails?.campaignUniqueText}/${contestDetails?.contestUniqueText}`,
      search: `${searchParams ? createSearchParams(searchParams) : ""}`,
    });
  };
  const profileHelpNavigate = () => {
    navigate(`/profile/help`);
  };

  let source = "";
  if (buildType == "highonevent") {
    source = `https://share.highonevent.com`;
  } else {
    source = `https://share.goviralit.com`;
  }

  let copyText = "";
  if (userIdFromLocalOrApi) {
    copyText =
      source +
      "/vidu" +
      userIdFromLocalOrApi +
      "o" +
      contestDetails?.orgId +
      "cp" +
      contestDetails?.campaignId +
      "cn" +
      contestDetails?.contestId +
      "e" +
      uploadSuccessFile?.videoId +
      "?from=app";
  } else {
    copyText =
      source +
      "/vid" +
      "o" +
      contestDetails?.orgId +
      "cp" +
      contestDetails?.campaignId +
      "cn" +
      contestDetails?.contestId +
      "e" +
      uploadSuccessFile?.videoId +
      "?from=app";
  }

  function copyLink() {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, [1000]);
    navigator.clipboard.writeText(copyText);
    window.document.execCommand("copy");
    // alert(copyText + "\n copied to clipboard")
  }
  const whatsapplink = () => {
    const encodedContent = encodeURIComponent(copyText);
    const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent
    );
    if (isMobileDevice) {
      const url = `https://wa.me/?text=${encodedContent}`;
      window.open(url, "_blank");
    } else {
      const url = `https://web.whatsapp.com/send?text=${encodedContent}`;
      window.open(url, "_blank");
    }
  };
  const facebooklink = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${copyText}`);
    return false;
  };
  const shareToTwitter = () => {
    window.open(`http://twitter.com/share?url=${copyText}`);
  };
  const shareToLinkedin = () => {
    window.open(
      `https://www.linkedin.com/shareArticle?mini=true&url=${copyText}`
    );
  };
  const getUserConcent = async () => {
    try {
      let config = {
        method: "patch",
        url: `${process.env.REACT_APP_USER_CONSENT}/${contestDetails?.orgId}/${contestDetails?.campaignId}/${contestDetails?.contestId}/${uploadSuccessFile?.videoId}?agreedToShowcase=${showcase}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      let result = await axios(config);
      if (result?.status == "success") {
        handleNavigateToContest();
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const WhatsAppMessage = `Hello Team Goviral, I would like to receive your WhatsApp notifications and that will greatly enhance my engagement and ensure that I don't miss out on any opportunities. Your participationId:GVUS${userIdFromLocalOrApi}o${uploadSuccessFile?.orgId}cp${uploadSuccessFile?.campaignId}cn${uploadSuccessFile?.contestId}e${uploadSuccessFile?.videoId}`;
  return (
    <div className="widthController z-20 relative " id="content">
      <div className={styles.profilePopup}>
        <div
          className={`overflow-auto no-scrollbar h-[100%] ${styles.successMainDiv}`}
        >
          <div className="flex flex-col items-cneter justify-center gap-[16px] w-[100%] mb-[16px]">
            <p
              className="text-large-bold"
              style={{ color: contestDetails?.buttonColor }}
            >
              {contestDetails?.entrySuccessResponse?.heading ||
                "Congratulations!"}
            </p>
            <pre className="text-small text-[#D4D4D4]">
              {contestDetails?.entrySuccessResponse?.text ||
                "Your submission is successful !"}
            </pre>
            {contestDetails?.entrySuccessResponse?.link && (
              <a
                className="text-small text-[#D4D4D4] flex w-full justify-center gap-[5px]"
                style={{ color: contestDetails?.buttonColor }}
                href={contestDetails?.entrySuccessResponse?.link}
                target="_blank"
              >
                <svg
                  width="15px"
                  height="15px"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.8333 12.5C16.2789 12.5 12.5 16.2789 12.5 20.8333V79.1667C12.5 83.7211 16.2789 87.5 20.8333 87.5H79.1667C83.7211 87.5 87.5 83.7211 87.5 79.1667V50H79.1667V79.1667H20.8333V20.8333H50V12.5H20.8333ZM58.3333 12.5V20.8333H73.2747L34.554 59.554L40.446 65.446L79.1667 26.7253V41.6667H87.5V12.5H58.3333Z"
                    fill={contestDetails?.buttonColor}
                  />
                </svg>
                {contestDetails?.entrySuccessResponse?.link}
              </a>
            )}
          </div>
          {(contestDetails.fileType?.startsWith("video") ||
            contestDetails.fileType?.startsWith("image")) &&
            contestDetails?.contestType !== "QUIZ_AW" && (
              <div className="w-[100%] h-[45%] ">
                <Carousel items={uploadSuccessFile?.fileUrl} />
              </div>
            )}
          {contestDetails.fileType?.startsWith("audio") && (
            <div className=" h-[70px] w-[100%] overflow-hidden flex items-center justify-center mb-[15px]">
              <AudioPlayerWithoutDownload
                fileUrl={
                  uploadSuccessFile?.fileUrl[0] &&
                  uploadSuccessFile?.fileUrl[0]?.fileUrl
                }
                fileName="my voice recording"
              />
            </div>
          )}
          {contestDetails?.contestType.startsWith("QUIZ") && (
            <>
              {/* <div className="flex w-full items-center py-[5px]">
                <input
                  type="radio"
                  name={`option-true`}
                  id={`option-true`}
                  checked={showcase}
                  onChange={() => setShowcase(true)}
                />

                <label htmlFor={`option-true`}>
                  I agree to show my result to all
                </label>
              </div>
              <div className="flex w-full items-center py-[5px]">
                <input
                  type="radio"
                  name={`option-false`}
                  id={`option-false`}
                  checked={!showcase}
                  onChange={() => setShowcase(false)}
                />

                <label htmlFor={`option-false`}>
                  No, I dont want to show my results
                </label>
              </div>
              <button onClick={getUserConcent}>Submit</button> */}
              <p className="py-[16px]">
                Mark: {entryUploadResponse?.quizMarksObtained}/
                {contestDetails?.shuffleCount || 5}
              </p>
              <div
                className="flex mb-[16px] p-[5px] rounded-[16px] text-black text-small"
                style={{
                  background: contestDetails?.buttonColor,
                }}
              >
                <div className="w-full">
                  <p>Correct</p>
                  <p className="text-regular">
                    {entryUploadResponse?.correctAnswerCount || "NIL"}
                  </p>
                </div>
                <div className="w-full">
                  <p>Wrong</p>
                  <p className="text-regular">
                    {entryUploadResponse?.wrongAnswerCount || "NIL"}
                  </p>
                </div>
              </div>
              {entryUploadResponse?.data?.map((question, index) => {
                return (
                  <div
                    className="flex gap-[5px] text-left mb-[20px]"
                    key={index}
                  >
                    {/* <div
                      style={{ background: `url(${question?.image}})` }}
                      className="w-[15%] h-auto "
                    /> */}
                    <div className="">
                      <p className=" text-regular text-[#ffffff]">
                        Q.{question?.question}
                      </p>
                      <p className=" text-[#D4D4D4] flex items-center gap-[5px] text-small">
                        Ans. {question?.answer}
                        {question?.answerMatches ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 16 12"
                            fill="none"
                          >
                            <path
                              d="M1 6L5.667 11L15 1"
                              stroke="#55A226"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.292923 1.70714C-0.0976171 1.31663 -0.0976448 0.683464 0.292863 0.292923C0.683371 -0.0976175 1.31654 -0.0976446 1.70708 0.292863L5.60509 4.19054L9.5031 0.292863C9.89364 -0.0976446 10.5268 -0.0976175 10.9173 0.292923C11.3078 0.683464 11.3078 1.31663 10.9173 1.70714L7.01936 5.60469L10.9172 9.50218C11.3077 9.89269 11.3077 10.5259 10.9172 10.9164C10.5267 11.3069 9.89357 11.307 9.50303 10.9165L5.60509 7.01885L1.70715 10.9165C1.31661 11.307 0.68344 11.3069 0.292933 10.9164C-0.0975747 10.5259 -0.0975477 9.89269 0.292993 9.50218L4.19081 5.60469L0.292923 1.70714Z"
                              fill="#F85959"
                            />
                          </svg>
                        )}
                      </p>
                      {!question?.answerMatches && question?.correctAnswer && (
                        <p className="text-[#D4D4D4] text-small">
                          Correct Answer. {question?.correctAnswer}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </>
          )}
          <p className="text-regular text-[#FFFFFD]  w-[100%] py-[10px]  mt-[16px] ">
            Status - Under Review
          </p>
          {contestDetails?.entrySuccessResponse?.text && (
            <p className="text-small text-[#D4D4D4]">
              Please note that entry will be published on GoViral once it is
              approved by the contest admin.
            </p>
          )}
          <div className="p-[20px] w-[100%]">
            <p
              className="text-regular text-[#CDCDCD]"
              style={{
                color: contestDetails?.buttonColor,
              }}
            >
              {details?.closedCampaign
                ? "Share with your colleagues"
                : "Share with friends"}
            </p>
            {!details?.closedCampaign && (
              <>
                <div className="seperatorBrandBg my-[20px]" />
                <div className="flex justify-between w-[100%] text-[#CDCDCD] text-small ">
                  <div
                    className="flex flex-col items-center gap-[6px] cursor-pointer"
                    onClick={facebooklink}
                  >
                    <img src={facebook} alt="" className="w-[46px] h-[46px]" />
                    <p>Facebook</p>
                  </div>
                  <div
                    className="flex flex-col items-center gap-[6px] cursor-pointer"
                    onClick={whatsapplink}
                  >
                    <img src={whatsapp} alt="" className="w-[46px] h-[46px]" />
                    <p>Whatsapp</p>
                  </div>
                  <div
                    className="flex flex-col items-center gap-[6px] cursor-pointer"
                    onClick={shareToTwitter}
                  >
                    <img src={twitter} alt="" className="w-[46px] h-[46px]" />
                    <p>Twitter</p>
                  </div>
                  <div
                    className="flex flex-col items-center gap-[6px] cursor-pointer"
                    onClick={shareToLinkedin}
                  >
                    <img src={LinkedIn} alt="" className="w-[46px] h-[46px]" />
                    <p>Linkedin</p>
                  </div>
                </div>
              </>
            )}
            <div className="seperator my-[20px]" />
            <div className="">
              <CopyToClipboard text={copyText}>
                <div
                  className="flex flex-row items-center justify-between w-[100%] "
                  onClick={copyLink}
                  tooltip="Copy to clipboard"
                >
                  <div className="w-[calc(100%-50px)]">
                    <p className="text-regular-medium">Copy the link </p>
                    <p className="text-small break-words text_1Line text-[#CDCDCD]">
                      {copyText}
                    </p>
                  </div>
                  <div className="w-[24px] h-[24px]">
                    {copied ? (
                      <img src={copySuccess} className="" />
                    ) : (
                      <img src={copyLinkImage} className="" />
                    )}
                  </div>
                </div>
              </CopyToClipboard>
            </div>
          </div>

          {!details?.closedCampaign && (
            <div className="w-[100%] py-[30px] px-[20px] text-center flex flex-col items-center gap-[16px]">
              <WhatsAppButton
                phoneNumber="+918618406454"
                message={WhatsAppMessage}
              />
              <p className="text-regular text-[#cdcdcd]">
                To receive notifications via whatsApp, Click the button above
              </p>
            </div>
          )}
          <button
            className="mx-auto text-regular mb-[16px] flex items-center justify-center gap-[10px]  py-[9px] px-[16px]  border-[1px] rounded-[40px] whitespace-nowrap w-fit"
            onClick={handleNavigateToContest}
            style={{
              color: contestDetails?.buttonColor,
              borderColor: contestDetails?.buttonColor,
            }}
          >
            Go back to contest
          </button>
          <div>
            {showDelete && (
              <UploadSucessDelete
                setShowDelete={setShowDelete}
                singleFileDetails={uploadSuccessFile}
                token={token}
                setUploadSucccess={setUploadSucccess}
                handleBackClick={handleBackClick}
              />
            )}
          </div>
          <div className="seperator" />
          <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
        </div>
      </div>
    </div>
  );
}

export default UploadSuccess;
